import React, { useContext, useRef, useState, useEffect, startTransition } from 'react';
import styled from '@emotion/styled';
import { breakpoints } from "@argo/principles";
import { HAMBURGER_MENU_ID } from '../header/utils/constants';
import { MYKBB_MENU_ID } from './utils/constants';
import UserContext from './UserContext';
import ContentSuppressorContext from './ContentSuppressorContext';
import useExternalElementClick from '../utils/useExternalElementclick';
import useEventBus from "../../../eventBus/useEventBus.js";
import { ZipcodeOverlay } from "@argo/applied-patterns";
import { ZipcodeModal, useZipcode } from '../../../zipcode-service/web';
import { getLocationString } from '../utils/getLocationString';
import LittleGuyLoader from './components/LittleGuyLoader.js';
const LittleGuyWebComponentContainer = styled.div`
  @media (min-width: ${breakpoints.max}px) {
    min-width: ${props => props?.slimLittleGuy ? '101px' : '129px'};
    height: 64px;
  }

  & user-profile-hydrator{
    display: ${({
  isLittleGuyLoading
}) => isLittleGuyLoading ? 'none' : 'inline'};
  }
`;
const MyKbb = ({
  showGoogleOneTap = true,
  setMenuOpenState,
  slimLittleGuy,
  useAuthRedirect = false
}) => {
  const mykbbContainerRef = useRef(null);
  const {
    suppressZipCode
  } = React.useContext(ContentSuppressorContext);
  const [showing, setShowing] = useState(false);
  const {
    zipcode,
    city,
    state
  } = !suppressZipCode ? useZipcode({
    withCity: true
  }) : {
    zipcode: '',
    city: '',
    state: ''
  };
  const [locationStr, setLocationStr] = useState('');
  const [zipCodeLink, setZipCodeLink] = useState(null);
  const [isHydrated, setIsHydrated] = useState(false);
  const {
    userInfo
  } = useContext(UserContext);
  const [isLittleGuyLoading, setIsLittleGuyLoading] = useState(true);
  useEventBus('userProfile.render', e => {
    startTransition(() => {
      setIsLittleGuyLoading(false);
    });
  });
  useEffect(() => {
    startTransition(() => {
      setLocationStr(getLocationString(city, state, zipcode));
    });
  }, [zipcode, city, state]);
  useEffect(() => {
    setIsHydrated(true);
  }, []);
  function onClickExternal(e) {
    const mobileNavMenuContainer = document.getElementById(HAMBURGER_MENU_ID).parentElement;
    if (mobileNavMenuContainer.contains(e.target)) {
      return false;
    }
    setMenuOpenState({
      menuId: MYKBB_MENU_ID,
      isMenuOpen: false
    });
  }
  const options = {
    targetComponentRef: mykbbContainerRef,
    ignoreOverlays: true
  };
  useExternalElementClick(onClickExternal, options);
  useEventBus('userProfile.locationClick', e => {
    startTransition(() => {
      setShowing(true);
      setZipCodeLink(e.zipCodeLink);
    });
  });
  return React.createElement(LittleGuyWebComponentContainer, {
    isLittleGuyLoading: isLittleGuyLoading,
    slimLittleGuy: slimLittleGuy
  }, isLittleGuyLoading && React.createElement(LittleGuyLoader, {
    slimLittleGuy: slimLittleGuy
  }), isHydrated ? React.createElement(React.Fragment, null, React.createElement("user-profile-hydrator", {
    brand: "kbb",
    "show-google-one-tap": showGoogleOneTap
  }, React.createElement("user-profile", {
    ref: mykbbContainerRef,
    "location-zipcode": locationStr,
    "saved-cars-length": userInfo?.savedCarsLength,
    "saved-listings-length": userInfo?.savedListingsLength,
    "saved-shoppers-car-length": userInfo?.savedShoppersCarLength,
    "saved-searches-length": userInfo?.savedSearchesLength,
    slim: slimLittleGuy,
    "use-auth-redirect": useAuthRedirect
  })), suppressZipCode ? React.createElement(React.Fragment, null) : React.createElement(ZipcodeModal, {
    showing: showing,
    setShowing: setShowing,
    component: ZipcodeOverlay,
    zipCodeLink: zipCodeLink
  })) : React.createElement(React.Fragment, null));
};
MyKbb.displayName = 'MyKbb';
export default MyKbb;